import React, { useCallback, useEffect, useState, useMemo } from 'react';
import { zeroPad } from 'react-countdown-now';
import { FaSpinner, FaInfoCircle, FaArrowUp, FaArrowDown } from 'react-icons/fa';
import { connect } from 'react-redux';
import { MdKeyboardArrowUp, MdKeyboardArrowDown } from 'react-icons/md';
import moment from 'moment';
import api from '../../axios-local-api';
import Box from '../../hoc/Box/Box';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import * as actions from '../../store/actions/index';
import classes from './RouterSpeedCheck.css';
import SpeedCheckResult from './SpeedCheckResult/SpeedCheckResult';
import PreviousSpeedCheckResult from './PreviousSpeedCheckResult';

const RouterSpeedCheck = (props) => {
  const [displayFullReport, setDisplayFullReport] = useState(false);
  const [upArrow, setUpArrow] = useState(false);
  const [counter, setCounter] = useState(props.speedCheckStartDate ? (Math.floor(Date.now() - props.speedCheckStartDate) / 1000) : 0);
  const [displayReport, setDisplayReport] = useState(false);
  const [isDesktop, setDesktop] = useState(window.innerWidth > 900);
  const startRouterSpeedCheck = useCallback(props.startSpeedTest)

  const { checkingWan, realWan } = props;
  let isConnected = !checkingWan && (realWan && realWan.connectionState === 'connected');


  useEffect(() => {
    const timer =
      counter >= 0 && setTimeout(() => setCounter(counter + 1), 1000);
    if (props.speedCheckStartDate === null) {
      setCounter(0)
      clearTimeout(timer)
    }
    return () => {
      clearTimeout(timer)
    }
  }, [counter, props.speedCheckStartDate]);


  const updateMedia = () => {
    setDesktop(window.innerWidth > 900);
  }

  useEffect(() => {
    window.addEventListener('resize', updateMedia);
    return () => window.removeEventListener('resize', updateMedia)
  })
  // const handleStartSpeedTest = () =>{
  //   startRouterSpeedCheck()
  // }

  const spinner = (
    <div id='SpeedTestRunCheck' style={{ padding: '20px', textAlign: 'center' }}>
      <div>
        <FaSpinner
          fontSize={'25px'}
          style={{ color: '#0073d1', marginRight: '5px' }}
          className={[
            classes.fa,
            classes.facircleonotch,
            classes.faspin,
            classes.fa3x,
            classes.fafw,
          ].join(' ')}
        />
      </div>
      {'Running Speed Test may take up to 90 seconds to complete and cannot be canceled.'}
      <br />

      {
        `${zeroPad(Math.floor(counter / 60))}:${zeroPad(Math.floor(counter % 60))}`
      }
    </div>
  )

  const extractLatestSpeedTestResultMaxMinBandwith = () => {
    if (!props.speedCheckResults || !displayReport) return null;
    const { speedCheckResults = [] } = props;
    return (
      <div className={classes.downloadUploadInfo}>
        <div className={classes.rightContent}>
          {
            speedCheckResults.length ? <React.Fragment>
              <div className={classes.info}><h2 id='DownloadSpeed'>{Number(speedCheckResults[0].down).toFixed(2)}</h2><h5>Mbps</h5></div>
              <span className={classes.icon}><FaArrowDown /> Download Speed</span>
            </React.Fragment> : <h2>N/A</h2>
          }
        </div>
        <div className={classes.separator} />
        <div className={classes.leftContent}>
          {
            speedCheckResults.length ? <React.Fragment>
              <div className={classes.info}><h2 id='UploadSpeed' >{Number(speedCheckResults[0].up).toFixed(2)}</h2><h5>Mbps</h5></div>
              <span className={classes.icon}><FaArrowUp /> Upload Speed</span>
            </React.Fragment> : <h2>N/A</h2>
          }
        </div>
      </div>
    )
  }

  // const extractLatestSpeedTestResultTimestamp = () => {
  //   if (!props.speedCheckResults || !displayReport) return null;
  //   const { speedCheckResults } = props;
  //   const date = speedCheckResults.length && speedCheckResults[0].timestamp;

  //   return (
  //     <div className={classes.routerSpeedRunnerInfo}>
  //       <div className={classes.content}>
  //         <span className={classes.contentLabel}>Last Ran:</span>
  //         <span id='LastRunTime' className={classes.contentValue}>{date ? moment(date).format('ddd MM/DD/YYYY hh:mm a') : 'N/A'}</span>
  //       </div>
  //     </div>
  //   )
  // }

  let arrow;
  if (upArrow) {
    arrow = <MdKeyboardArrowUp color={'gray'} size={'30px'} style={{}} />;
  } else {
    arrow = <MdKeyboardArrowDown color={'gray'} size={'30px'} />;
  }
  
  if (props.speedCheckStartDate && !displayReport) {
    setDisplayReport(true);
  }

  let routerSpeedCheckLabel =
    (
      <button
        style={{ color: isConnected ? '#0073d1' : 'dimgrey' }}
        id="routerSpeedCheck"
        className={classes.RegularButton}
        disabled={!isConnected || props.speedCheckStartDate}
        onClick={startRouterSpeedCheck}
      >
        {'Run Test'}
      </button>
    )

  const errorMessage = useMemo(() => {
    let message = '';
    let displayWarningIcon = false;

    if (!props.speedCheckResults || !displayReport){
      message = 'No speed test results are available.';
    }else{
      message = 'Something went wrong. Please try again shortly.'
      displayWarningIcon = true;
    }

    if(!!props.speedCheckResultsError && !props.isResetFuncCalled){
      return (
          <div className={[classes.alertMessageContainer, classes.alertError].join(' ')}>
           { displayWarningIcon &&  <span><FaInfoCircle color="red" size={30} /></span> }
            <span>{ message }</span>
          </div>
        )
      }

  }, [props.speedCheckResultsError, props.isResetFuncCalled, props.speedCheckResults, displayReport]);


  return (
    <Box>
      <div className={classes.RouterSpeedCheck}>
        <div className={classes.TitleArea}>
          <div className={classes.TitleLeft}>
            <h3 className={classes.ComponentTitle}>Router Speed Test</h3>
          </div>
          <div className={classes.TitleRight}>
            {routerSpeedCheckLabel}
          </div>
        </div>
        <div className={classes.BodyArea}>
          {
            !!props.speedCheckResultsError && !props.isResetFuncCalled
              ? errorMessage
              : props.speedCheckStartDate
                ? spinner
                : (
                  <React.Fragment>
                    <div className={[classes.alertMessageContainer].join(' ')}>
                      <span><FaInfoCircle color="#38a9f9" size={24} /></span>
                      {isConnected && <span id='SpeedTestMsg' className={classes.alertMessage}>Reminder: Test results may vary if customer has devices in use</span>}
                      {!isConnected && <span id='SpeedTestOff' className={classes.alertMessage}>Speed Check is currently unavailable. Router is offline </span>}
                    </div>
                    {extractLatestSpeedTestResultMaxMinBandwith()}
                    {/* {extractLatestSpeedTestResultTimestamp()} */}
                    {/* {
                      displayReport && props.speedCheckResults &&
                      <div
                        id="routerSpeedCheckViewFullReport"
                        style={{ display: 'flex', paddingBottom: '10px' }}
                        onClick={() => {
                          setDisplayFullReport(displayFullReport => !displayFullReport);
                          setUpArrow(upArrow => !upArrow);
                        }}
                      >
                        {arrow}
                        <button
                          id="routerSpeedCheckViewFullReportBtn"
                          className={classes.RegularButton}
                        >
                          {btnName}
                        </button>
                      </div>
                    } */}
                  
                  </React.Fragment>
                )
          }
        </div>
      </div>
    </Box>
  )
}

const mapStateToProps = state => ({
  speedCheckResults: state.speedCheck.speedCheckResults,
  speedCheckStartDate: state.speedCheck.speedCheckStartDate,
  speedCheckResultsError: state.speedCheck.speedCheckResultsError,
  checkingWan: state.wan.checkingWan,
  realWan: state.wan.realWan,
  isResetFuncCalled: state.speedCheck.isResetFuncCalled
})

const mapDispatchToProps = (dispatch) => {
  return {
    startSpeedTest: () => dispatch(actions.getSpeedCheckStartDate()),
    resetRouterSpeedCheck: () => dispatch(actions.resetSpeedCheckResultsFlag())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(RouterSpeedCheck, api));
